// Custom product variant stock code
let fetchNewStock = async function (variantId) {
  const container = document.getElementById('productAvailabilityContainer');
  container.innerHTML = '<p>Ophalen van de voorraad...</p>';
  return fetch('/apps/elasticweb/webhooks/shopify/offers/' + variantId + '/stock')
    .then((response) => {
      return response.json();
    });
};

let updateStockIndicators = function (stocks) {
  const container = document.getElementById('productAvailabilityContainer');

  let availableLocations = [];
  // check for available stock
  for (let key in stocks) {
    if (stocks.hasOwnProperty(key)) {
      const location = stocks[key];
      if (location.quantity > 0) {
        availableLocations.push(location.label);
      }
    }
  }

  let html = '<ul class="stock-list">';

  // check if any location has stock
  if (availableLocations.length > 0) {
    if (availableLocations.length > 1) {
      // we get the last element from the array for correct text format
      const lastLocation = availableLocations.pop();
      html += '<li>Op voorraad in ' + availableLocations.join(', ') + ' en ' + lastLocation + '</li>';
    } else {
      html += '<li>Op voorraad in ' + availableLocations.join(', ') + '</li>';
    }
    // we check if there is any stock location defined in CS, if no results are found this should not display the text
  } else if (Object.keys(stocks).length > 0) {
    // no stock left on any location
    html += '<li class="out-of-stock">Niet meer op voorraad</li>';
  }

  html += '</ul>';
  container.innerHTML = html;
};

// initialize the stock
(async function () {
  // variable is defined in main-product.liquid
  let stocks = await fetchNewStock(selected_or_first_available_variant);
  updateStockIndicators(stocks);
})();

// initialize listeners
(function () {
  let elementCurrentVariant = document.querySelectorAll('[name="id"]');
  Array.from(elementCurrentVariant).forEach((function (e) {
    e.removeAttribute('disabled');
  }));
  const productOptions = document.getElementsByClassName('productOption');
  if (productOptions) {
    eventType = 'click', 'dropdown' === variantStyle && (eventType = 'change'), Array.from(productOptions).forEach((function (productOption) {
      productOption.addEventListener(eventType, (() => {
        const contentSection = productOption.closest('.yv_product_content_section');
        setTimeout((async function () {
          const productLoopVariants = Array.from(contentSection.querySelectorAll('.product-loop-variants'));
          const currentVariant = variantChange('dropdown' === variantStyle ? productLoopVariants.map((productOption => {
            return Array.from(productOption.querySelectorAll('select')).find((productOption => productOption)).value;
          })) : productLoopVariants.map((productOption => {
            return Array.from(productOption.querySelectorAll('input')).find((productOption => productOption.checked)).value;
          })), 'options', contentSection);

          // undefined if not found
          if (currentVariant) {
            // check the live stock of product
            let stocks = await fetchNewStock(currentVariant.id);
            updateStockIndicators(stocks);
          } else {
            // not available
            updateStockIndicators({});
          }
        }), 500);
      }));
    }));
  }
})();
